import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ContactUs} from '../../components/index';
import {get} from '../../redux/modules/contacts';

class Contacts extends PureComponent {

  componentWillMount() {
    this.props.getAction();
  }

  render() {
    const {contacts: {values: {text, contacts}, values, isFetching}} = this.props;
    if (isFetching) {
      return <div/>
    }

    return (
      <div className="main">
        <ContactUs text={text} contacts={contacts}/>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      contacts: state.contacts
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getAction: get
      }, dispatch);
  }
)(Contacts);



// WEBPACK FOOTER //
// ./src/containers/contacts/Contacts.js